import { Mapper } from './base-mapper';
import type { CustomReportDTO } from '@/core/dto/custom-report';

export type CustomReportOption = {
	value: string;
	label: string;
};

export class GetCustomReportOptionsMapper extends Mapper<CustomReportOption[]> {
	constructor(private readonly data: CustomReportDTO) {
		super();
	}

	toDomain(): CustomReportOption[] {
		return this.data.map((item) => ({ value: item.id, label: item.acronym }));
	}
}
